/** */
export const ADD_BALLANCE = 'add user balance to store';

export const addUserBalance = (payload) => ({
  type: ADD_BALLANCE,
  payload
});
